import { LOG_OUT } from '../actions/types';
import {combineReducers} from 'redux';
import alertReducer from './alertReducer';
import authReducer from './authReducer';
import carDetailListReducer from './carDetailListReducer';
import accountsReducer from './accountsReducer';
import accountDropdownReducer from './accountDropdownReducer';
import agreementReducer from './agreementReducer';
import proformaInvoicesReducer from './proformaInvoicesReducer';
import finalInvoicesReducer from './finalInvoicesReducer';
import reProcessingPlan from './reProcessingPlan';
import installmentReducer from './installmentReducer';

const appReducer = combineReducers ({
    alerts: alertReducer,
    auth:authReducer,
    carDetailList: carDetailListReducer,
    accounts: accountsReducer,
    accountDropdown: accountDropdownReducer,
    agreements: agreementReducer,
    proformaInvoices: proformaInvoicesReducer,
    finalInvoices : finalInvoicesReducer,
    reProcessing: reProcessingPlan,
    installments:installmentReducer
});

const rootReducer = (state, action) => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === LOG_OUT) {
        sessionStorage.removeItem("isSignedIn");
        sessionStorage.removeItem("user");
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;

